import './functions';
import './logic';
import './variables';
import { wrapperBuilder } from './build';

export const VinculationsWrapper = wrapperBuilder.build();
